import React from 'react';

const NotFound = () => {
    return (
        <div>
            Ops, Not Found
        </div>
    )
}

export default NotFound;
